module.exports = __webpack_public_path__ + "img/APVRS2026.489d024e.png";